import React from 'react';
import Icon from './Icon';

interface SelectPropsBase {
  options: string[];
  value?: string;
  onValue: (val: string) => void;
  emptyLabel?: string;
}

type SelectProps = SelectPropsBase & React.SelectHTMLAttributes<HTMLSelectElement>;

export default function Select(props: SelectProps) {
  const { className: propClasses, options, value, onValue, emptyLabel, ...rest } = props;

  const classes = [
    'bg-white border border-border rounded-lg pl-3 pr-8 py-2 w-full relative text-sm',
  ];
  if (!value || value === '') classes.push('text-muted');
  classes.push('go-select');

  const containerClasses = ['relative'];
  if (propClasses) containerClasses.push(propClasses);
  containerClasses.push('go-select-container');

  return (
    <div className={containerClasses.join(' ')}>
      <select
        className={classes.join(' ')}
        value={value}
        onChange={e => onValue(e.target.value)}
        {...rest}
      >
        <option value="" className="text-muted text-sm">
          {props.emptyLabel || '--'}
        </option>
        {options.map(opt => (
          <option key={opt} value={opt} className="text-base text-sm">
            {opt}
          </option>
        ))}
      </select>
      <Icon
        className="absolute mr-4"
        style={{
          top: '50%',
          right: 0,
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
        }}
        icon={['fass', 'caret-down']}
      />
    </div>
  );
}
